<script lang="ts" setup>
// @ts-ignore
import { SplideSlide } from '@splidejs/vue-splide'

export interface WidgetNewsProps {
    data: {
        tag: string
        title: string
        subtitle: string
        data: ProductBoxColored[]
    }
    headingLevel: HeadingLevel
}

const props = defineProps<WidgetNewsProps>()
</script>

<template>
  <section data-cy="widget_product-news">
    <Tracker :data="{ position: props.data.title }">
      <Box
        decor-position="top-left"
        color="green-light"
        class="rounded pt-12"
      >
        <BoxHeader
          :heading="props.data.title"
          :heading-level="props.headingLevel"
          :subtitle="props.data.subtitle"
        >
          <template #tag>
            <Tag
              class="text-uppercase"
              :decor="false"
              size="small"
              background-color="green-2"
            >
              {{ props.data.tag }}
            </Tag>
          </template>
        </BoxHeader>
        <Slider data-cy="widget_product_news_slider">
          <SplideSlide
            v-for="(item, index) in props.data.data"
            :key="index"
            class="translate-y-hover-wrapper pt-2"
          >
            <ProductBoxColored
              :item="item"
              heading-level="h3"
            />
          </SplideSlide>
        </Slider>
      </Box>
    </Tracker>
  </section>
</template>
